(() => {
  const header = document.querySelector('#shopify__header__section .header_bottom');
  if (!header || header.dataset.lrGlassReady) return;
  header.dataset.lrGlassReady = 'true';
  let frame;
  const update = () => {
    frame = null;
    header.classList.toggle('lr-header-scrolled', window.scrollY > 24);
  };
  window.addEventListener('scroll', () => {
    if (!frame) frame = requestAnimationFrame(update);
  }, { passive:true });
  window.addEventListener('pageshow', update);
  update();
})();
